<i class="delivery-type-icon wa-icon-calendar-unknown" *ngIf="!type"></i>
<i class="delivery-type-icon icon-pickup-shop" *ngIf="type === types.PICKUP"></i>
<i class="delivery-type-icon icon-truck-delivery-2" *ngIf="type === types.DELIVERY_TO_DOOR"></i>
